import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { useAuth } from "../contexts/auth";
import { postToolsURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";


function CreateTool({
    isOpen,
    onClose,
    successCallback,
}) {

    const [ name, setName ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ imageFile, setImageFile ] = useState(null);
    const [ quantity, setQuantity ] = useState("0");


    const [ invName, setInvName ] = useState(null);
    const [ invDescription, setInvDescription ] = useState(null);
    const [ invQuantity, setInvQuantity ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postTools = async (e) => {
        e.preventDefault();

        setSubmitting(true);


        let compressedFile;
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 300,
          useWebWorker: true
        }
        try {
            compressedFile = await imageCompression(imageFile, options);
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        } catch (error) {
            setErrors(['Failed compressing image.']);
            // console.log(error);
        }

        if (!compressedFile) {
            setSubmitting(false);
            return;
        }

        setErrors([]);

        let cover = await fileToBase64(compressedFile);
        cover = cover.replace('data:image/png;base64,', '');
        cover = cover.replace('data:image/jpeg;base64,', '');
        cover = cover.replace('data:image/jpg;base64,', '');

        // console.log(cover);

        // console.log(description, password);
        axios.post(postToolsURL, {
            name,
            description,
            quantity,
            cover: cover, 
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setName('');
                setDescription('');
                setImageFile(null);
                setQuantity("0");
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {


        if (!validator.isEmpty(name)) {
            setInvName(name.length < 1);
        }

        if (!validator.isEmpty(description)) {
            setInvDescription(description.length < 1);
        }

        if (!validator.isEmpty(quantity)) {
            setInvQuantity(!validator.isNumeric(quantity));
        }

    }, [name, description, quantity]);

    const fileToBase64 = async (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (e) => reject(e)
        }
    );




    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Create New Tool</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <form onSubmit={postTools}>
                        <FormControl >
                            {/* Name */}
                            <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Name"
                                    size="md" 
                                    isInvalid={invName === true}
                                    isRequired={true}
                                    value={name} 
                                    onChange={e => setName(e.target.value)}
                                />
                            </Box>
                            
                            {/* Description */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Description
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Enter Description Address"
                                size="md" 
                                isInvalid={invDescription === true}
                                isRequired={true}
                                value={description} 
                                onChange={e => setDescription(e.target.value)}
                            />

                            {/* Quantity */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Quantity
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Enter Quantity"
                                size="md" 
                                isInvalid={invQuantity === true}
                                isRequired={true}
                                value={quantity} 
                                onChange={e => setQuantity(e.target.value)}
                            />

                            
                            {/* Icon */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Icon (50x50)
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="file"
                                accept="image/*"
                                placeholder="Select Image"
                                size="md" 
                                textAlign="start" 
                                verticalAlign="middle"
                                // isInvalid={invDescription === true}
                                isRequired={true}
                                onChange={e => setImageFile(e.target.files[0])}
                            />


                            <Flex w="100%" flexDir="column">
                                { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                            </Flex>
                            <Button
                                fontSize="10px"
                                type="submit"
                                bg="teal.300"
                                w="100%"
                                h="45"
                                mb="20px"
                                color="white"
                                mt="0px"
                                _hover={{
                                bg: "teal.200",
                                }}
                                _active={{
                                bg: "teal.400",
                                }}
                                isDisabled={submitting}
                            >
                                SUBMIT
                            </Button>
                        </FormControl>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default CreateTool;
